// extracted by mini-css-extract-plugin
export var active = "article-module--active--48d39";
export var articleList = "article-module--article-list--86f53";
export var articles = "article-module--articles--0472d";
export var articlesTabs = "article-module--articles-tabs--9658f";
export var articlesTabsItem = "article-module--articles-tabs-item--a41a5";
export var articlesTabsItemTag = "article-module--articles-tabs-item-tag--0870a";